const TOKEN = 'jwt'

export default {
  logout() {
    localStorage.removeItem(TOKEN)
    localStorage.clear()
  },

  isAuthenticated() {
    return !!localStorage.getItem(TOKEN)
  },

  redirect() {
    window.location.pathname = localStorage.redirectAfterLogin
      ? localStorage.redirectAfterLogin
      : 'dashboard'
    delete localStorage.redirectAfterLogin
  },
}
